import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGlobalUIStore = defineStore('globalUI', () => {
  const loginModalVisible = ref(false)
  const loginModalPrefill = ref('')
  const registerPlace = ref('Head')
  function openLoginModal(prefill = '', place = 'Head') {
    loginModalPrefill.value = prefill
    registerPlace.value = place
    loginModalVisible.value = true
  }
  function closeLoginModal() {
    loginModalVisible.value = false
    loginModalPrefill.value = ''
    registerPlace.value = 'Head'
  }
  function setRegisterPlace(place) {
    registerPlace.value = place
  }
  return {
    loginModalVisible,
    loginModalPrefill,
    registerPlace,
    openLoginModal,
    closeLoginModal,
    setRegisterPlace
  }
}) 